  <template>
  <div class="publicity">
    <table-temp
      title
      :flag="1"
      :tableData="tableData"
      :columnData="tableConf"
      :isEdit="false"
    ></table-temp>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import TableTemp from "@table/table2";
import { townPublicity } from "common/js/api";

export default {
  name: "Publicity",

  components: {
    TableTemp,
  },

  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      total: 0,
      cellStyle: {
        "text-align": "center",
      },
      tableData: [],
      multipleSelection: [],
      // 表格列配置
      tableConf: [
        {
          label: "企业名称",
          field: "institutionName",
        },
        {
          label: "机构类型",
          field: "institutionType",
        },
        {
          label: "工商注册时间",
          field: "registrationDate",
        },
        {
          label: "入驻时间",
          field: "enterTime",
        },
      ],
    };
  },

  created() {
    this.getList();
  },

  methods: {
    async getList() {
      const params = {
        page: this.currentPage,
        size: this.pageSize,
      };

      const { result } = await townPublicity(params);
      this.tableData = result.list.map((item) => ({
        institutionType:
          item.institutionCode.slice(0, 2) == "GL"
            ? "基金管理机构"
            : "基金机构",
        institutionName: item.institutionName,
        registrationDate: item.registrationDate,
        enterTime: this.$moment(item.enterTime).format("YYYY-MM-DD"),
      }));
      this.currentPage = result.pageNum;
      this.pageSize = result.pageSize;
      this.total = result.total;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.pagination {
  text-align: center;
  // margin-top: 30px;
}
::v-deep .type-title::before {
  display: none;
}
.publicity {
  height: 100%;
  display: flex;
  flex-direction: column;
  .table-item{
    height: calc(100% - 74px);
  }
}
</style>

